import { ref } from 'vue';
import { projectAuth } from '../firebase/config';
import router from '../router';
import firebase from 'firebase/app'
import 'firebase/auth'
import store from '@/store';

const error = ref(null)
const passwordResetLink = async (email) => {
    error.value = null
    await firebase.auth().sendPasswordResetEmail(email).then(() => {
        error.value = null
    }).catch((err) => {
        store.dispatch('printLog', {text:'error while sending password reset link', log:err.message, type:'error'})
        error.value = 'Error while sending link'
    });
}

const sendPasswordResetLink = () => {
  return { error, passwordResetLink};
}

export default sendPasswordResetLink